import siteDecoder from './site'

export default (sites) => {
  return sites.map(site => siteDecoder(site))
}
